import React from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    content: ['content'],
    button: ['close'],
    never_show_button: ["don't show"]
  }
};

const FloatingBottomSheetTracking = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        background: 'none'
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          alignItems: 'end',
          gap: '10px',
          paddingBottom: '100px'
        }}
      >
        <div>
          <EditTracking value={tracking?.button?.[0]} type="button" />
        </div>
        <div>
          <EditTracking
            value={tracking?.never_show_button?.[0]}
            type="never_show_button"
          />
        </div>
        <div style={{ marginTop: '100px' }}>
          <EditTracking value={tracking?.content?.[0]} type="content" />
        </div>
      </div>
    </div>
  );
};

export default FloatingBottomSheetTracking;
